<template>
  <div>
    <b-row class="pb-2">
      <b-col cols="8">
        <h6 :class="['font-weight-' + (selected ? 'bold' : 'normal')]">
          {{ nameFormatterCallback('categories', title) }}
        </h6>
      </b-col>
      <b-col cols="1">
        <b-form-checkbox switch v-model="selected" :disabled="disableSelection"></b-form-checkbox>
      </b-col>
      <b-col cols="3"> </b-col>
    </b-row>

    <b-row v-for="(item, index) in list" :key="index">
      <b-col>
        <b-row class="py-1">
          <b-col cols="8">
            <span :class="!selected ? 'disableText' : ''">{{ nameFormatterCallback('codes', item.indicator) }}</span>
          </b-col>
          <b-col cols="1">
            <b-form-checkbox
              switch
              v-model="item.selected"
              :disabled="!selected"
              @change="$emit('on-item-select', index)"
            ></b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <div class="d-flex" v-if="item.selected">
              <div class="mr-auto">
                <b-input
                  size="sm"
                  type="text"
                  lazy-formatter
                  autocomplete="off"
                  v-model="item.weight"
                  :disabled="!item.selected"
                  :placeholder="inputPlaceholder"
                  :formatter="valueFormatterCallback"
                  @keyup.native="onEnterPress"
                  @keypress="keypressCallback"
                  @focus="$emit('on-focus', { item: item, i: index })"
                  class="d-inline custom-weight-input"
                ></b-input>
              </div>
              <div>
                <slot name="tooltip" :index="index" :family="item.family"></slot>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row no-gutters class="reset-all">
      <b-col>
        <div class="text-right">
          <b-button class="btn-link-font" variant="link" :disabled="!selected" @click="onReset()">
            {{ resetLabel }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
    disableSelection: {
      type: Boolean,
      default: false,
    },
    inputPlaceholder: {
      type: String,
      default: '',
    },
    resetLabel: {
      type: String,
      required: true,
    },
    defaultSelectedValue: {
      type: Boolean,
      default: false,
    },
    keypressCallback: {
      type: Function,
      required: true,
    },
    nameFormatterCallback: {
      type: Function,
      required: true,
    },
    valueFormatterCallback: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      selectedValue: this.defaultSelectedValue,
    }
  },

  computed: {
    selected: {
      get() {
        return this.selectedValue
      },
      set(newVal) {
        this.$emit('on-select')
        this.selectedValue = newVal
      },
    },
  },

  methods: {
    onReset() {
      this.selected = false
      this.$emit('on-reset')
    },
    onEnterPress(event) {
      return [13, 27].includes(event.keyCode) ? this.valueFormatterCallback() : null
    },
  },
}
</script>

<style lang="scss" scoped>
.disableText {
  color: var(--gray8);
}
.btn-link-font {
  padding: 0 !important;
  font-size: 0.8rem;
}
.selected-section {
  color: var(--primary);
}
.text-color-primary {
  color: var(--primary);
}
.custom-weight-input {
  padding: 0.2rem 0.3rem;
  font-size: 0.7rem;
}
.reset-all {
  position: absolute;
  bottom: 1.5rem;
  right: 3rem;
}
</style>
